import { SERVICE_URLS } from '../config/urls';

export interface Testimonial {
  id: number;
  name: string;
  role: string;
  company: string;
  image: string;
  content: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "JUDr. Martin Friedrich",
    role: "Advokát",
    company: "Slovenská advokátska komora",
    image: `${SERVICE_URLS.AVATAR_PLACEHOLDER}/150?img=5`,
    content: "Kurz o umelej inteligencii mi poskytol praktický prehľad a návod na využitie umelej inteligencie v právnej praxi. Praktické príklady a profesionálny prístup lektora z toho robí must-have pre každého moderného právnika."
  },
  {
    id: 2,
    name: "Doc. JUDr. Jana Horvátová, PhD.",
    role: "Docentka",
    company: "Univerzita Pavla Jozefa Šafárika",
    image: `${SERVICE_URLS.AVATAR_PLACEHOLDER}/150?img=6`,
    content: "Veľmi užitočný kurz, ktorý prepája praktické poznatky lektorov s využitím AI pri rôznych činnostiach. Získala som cenné vedomosti o budúcnosti využitia umelej inteligencie v rámci mojich záujmov a profesionálnej kariéry"
  },
  {
    id: 3,
    name: "Ing. Vladimír Novotný",
    role: "Partner",
    company: "Austin Powder Slovakia",
    image: `${SERVICE_URLS.AVATAR_PLACEHOLDER}/150?img=7`,
    content: "Základný aj pokročilý kurz AI poskytol mne a našej spoločnosti presne to, čo som potreboval na prekopanie starých zavedených a zastaralých spôsobov managementu. Oceňujem najmä praktické ukážky implementácie AI nástrojov v praxi."
  }
];